import axios from 'axios';
import apiClient from './api/client';
import config from '../utils/config';

export interface AIConfigRequest {
  prompt: string;
  existingConfig?: any;
}

export interface AIConfigResponse {
  config: any;
  explanation: string;
  suggestions: string[];
}

class AIConfigService {
  private static instance: AIConfigService;
  private baseUrl: string;

  private constructor() {
    this.baseUrl = config.api.baseUrl;
  }

  public static getInstance(): AIConfigService {
    if (!AIConfigService.instance) {
      AIConfigService.instance = new AIConfigService();
    }
    return AIConfigService.instance;
  }

  async generateConfig(request: AIConfigRequest): Promise<AIConfigResponse> {
    const response = await apiClient.post(`/api/v1/ai/config/generate`, request);
    return response.data;
  }

  async validateConfig(config: any): Promise<{ isValid: boolean; errors: string[] }> {
    const response = await apiClient.post(`/api/v1/ai/config/validate`, { config });
    return response.data;
  }

  async suggestImprovements(config: any): Promise<string[]> {
    const response = await apiClient.post(`/api/v1/ai/config/suggest`, { config });
    return response.data.suggestions;
  }
}

export default AIConfigService; 